import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import config from '../config';

function UnsubscribeAll() {
  const { email } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');
  const [count, setCount] = useState(0);

  useEffect(() => {
    const handleUnsubscribeAll = async () => {
      if (!email) {
        setStatus('error');
        setMessage('Email inválido');
        return;
      }

      try {
        const response = await fetch(`${config.API_BASE_URL}/api/subscriptions/unsubscribe-all/${email}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();

        if (data.success) {
          setStatus('success');
          setMessage(data.message);
          setCount(data.count || 0);
        } else {
          setStatus('error');
          setMessage(data.message || 'Error al procesar la desuscripción');
        }
      } catch (error) {
        console.error('Error:', error);
        setStatus('error');
        setMessage('Error al conectar con el servidor. Por favor, intenta de nuevo más tarde.');
      }
    };

    handleUnsubscribeAll();
  }, [email]);

  return (
    <div className="unsubscribe-page">
      <div className="unsubscribe-container">
        {status === 'loading' && (
          <div className="loading-state">
            <div className="spinner"></div>
            <h2>Procesando tu solicitud...</h2>
          </div>
        )}

        {status === 'success' && (
          <div className="success-state">
            <div className="success-icon">✓</div>
            <h2>Desuscripción completa</h2>
            <p className="message">{message}</p>
            {count > 0 && (
              <p className="info-text">
                Se han desactivado <strong>{count}</strong> {count === 1 ? 'suscripción' : 'suscripciones'}.
              </p>
            )}
            <p className="info-text">
              Ya no recibirás ninguna notificación de nuestra comunidad de oración.
            </p>
            <p className="email-info">
              Email: <strong>{decodeURIComponent(email)}</strong>
            </p>
            <div className="info-box">
              <p>
                💙 <strong>Lamentamos verte partir</strong>
              </p>
              <p>
                Siempre serás bienvenido/a de vuelta. Si cambias de opinión, 
                puedes crear un nuevo pedido y suscribirte nuevamente cuando lo desees.
              </p>
            </div>
            <div className="action-buttons">
              <button onClick={() => navigate('/')} className="btn-primary">
                Volver al inicio
              </button>
              <button onClick={() => navigate('/nuevo-pedido')} className="btn-secondary">
                Hacer un nuevo pedido
              </button>
            </div>
          </div>
        )}

        {status === 'error' && (
          <div className="error-state">
            <div className="error-icon">⚠️</div>
            <h2>Error en la desuscripción</h2>
            <p className="message">{message}</p>
            <div className="action-buttons">
              <button onClick={() => navigate('/')} className="btn-primary">
                Volver al inicio
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UnsubscribeAll;

